import { gql } from '@apollo/client';
import {
  FetchEntitlementsForCartQuery,
  FetchEntitlementsForCartInitialLoadQuery,
  EnrichEntitlementsForCartQuery,
} from '@css-xp/ppc-cart-common';

export const fetchEntitlementsForCart = gql`
  ${FetchEntitlementsForCartQuery}
`;

export const fetchEntitlementsForCartInitialLoad = gql`
  ${FetchEntitlementsForCartInitialLoadQuery}
`;

export const enrichEntitlementsForCart = gql`
  ${EnrichEntitlementsForCartQuery}
`;
